import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  // TODO: Check if this is needed as a singleton in SHB-13303
  providedIn: 'root',
})
export class PlanWizardService {
  paymentValid$ = new BehaviorSubject(false);
  paymentReady$ = new BehaviorSubject(false);
}
